import { MessagingHelper } from "../helpers/MessagingHelper";
import { AssistanceAuxDataDTO } from "../models/Assistance/AssistanceAuxDataDTO";
import { CancelMotiveDTO } from "../models/Generic/CancelMotiveDTO";
import { CreateScheduleDTO } from "../models/Scheduler/CreateScheduleDTO";
import { EditScheduleDTO } from "../models/Scheduler/EditScheduleDTO";
import { GetSchedulerListDTO } from "../models/Scheduler/GetSchedulerListDTO";
import { ScheduleDetailsDTO } from "../models/Scheduler/ScheduleDetailsDTO";
import { ScheduleSearchResultDTO } from "../models/Scheduler/SchedulerListDTO";
import { APIService } from "./APIService";

export class SchedulerService {
  async GetAll(
    data: GetSchedulerListDTO
  ): Promise<MessagingHelper<ScheduleSearchResultDTO[]>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Schedule/GetAll`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<ScheduleSearchResultDTO[]>(
        false,
        "Erro ao ligar ao servidor para obter os agendamentos",
        []
      );
    }
  }

  async Create(data: CreateScheduleDTO): Promise<MessagingHelper<AssistanceAuxDataDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Schedule/Create`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceAuxDataDTO | null>(
        false,
        "Erro ao ligar ao servidor para criar o agendamento",
        null
      );
    }
  }

  async Edit(data: EditScheduleDTO): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Schedule/Edit`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para editar o agendamento",
        null
      );
    }
  }

  async GetById(id: number): Promise<MessagingHelper<ScheduleDetailsDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Schedule/getById?id=${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para obter os detalhes do agendamento",
        null
      );
    }
  }

  async Cancel(id: Number | null, requestObj: CancelMotiveDTO | null): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().put(
        `${APIService.GetURL()}/Schedule/Cancel?id=${id}`,
        {
          ...requestObj,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para cancelar o agendamento",
        null
      );
    }
  }
}
